// import React, { memo, useRef, useState, useEffect, useContext } from 'react';
import React, { memo, useRef, useContext } from 'react';
// import { Card } from 'tea-component';
import { useMemoizedFn } from 'ahooks';
import { context as Context } from '@gp/components/Context';
import Loading from '@gp/components/Loading';
import Filter from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/KeyInformationTable/components/Filter';
import TableList from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/KeyInformationTable/components/TableList';
import useDownload, { createDownloadService } from '@gp/hooks/useDownload';
import useKeyInformationTable from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/KeyInformationTable/useKeyInformationTable';
import { downloadStudioOverallOverviewTableData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { formatDateStr } from '@gp/utils/common';
import '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/KeyInformationTable/index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';
import DataTime from '@/pages/globalpedia/components/DataTime';

/* const calcIsColumnWrap = (node: HTMLElement | null): boolean => {
  if (node === null) return false;
  const widthStyleValue = window
    .getComputedStyle(node, null)
    .getPropertyValue('width');
  const width = Number.parseFloat(widthStyleValue);
  // 宽度小于 1636时，折行处理
  return width < 1636;
}; */

// 计算 Key Information At A Glance宽表 部分列是否折行逻辑
// const useTableColumnWrap = (rootNode: any, isFoldMenu: boolean) => {
//   const [isTableColumnWrap, setIsTableColumnWrap] = useState(false);

//   const calc = useMemoizedFn(() => {
//     const isTableColumnWrap = calcIsColumnWrap(rootNode?.current);
//     setIsTableColumnWrap(isTableColumnWrap);
//   });

//   useEffect(() => {
//     setTimeout(() => {
//       calc();
//     }, 0);
//   }, [isFoldMenu]);

//   useEffect(() => {
//     window.addEventListener('resize', calc, false);

//     return () => {
//       window.removeEventListener('resize', calc);
//     };
//   }, [calc]);

//   return { isTableColumnWrap };
// };

const KeyInformationTable: React.FC<
IStudioOverallOverviewKeyInformationTableProps
> = (props) => {
  const { isLoading: isLoadingProps } = props;

  const rootNode = useRef<HTMLDivElement>(null);
  const filterComp = useRef<any>(null);

  const { commonData } = useContext<IStudioOverallOverviewContext>(Context);

  // const { isTableColumnWrap } = useTableColumnWrap(rootNode, isFoldMenu);

  const {
    // isLoading: isLoadingInner,
    isTableInnerLoading,
    formModel,
    orderState,
    categoryFormatter,
    businessFormatter,
    handleOrderStateChange,
    handleFilterChange,
    handleSearchChange,
    handleTableStatusChange,
    records,
    currentParams,
    prevParams,
    reqError,
    dataTime,
    fetchParams,
  } = useKeyInformationTable({
    filterComp,
    isCommonDataLoading: !!isLoadingProps,
    commonData,
  });
  const dataTimeFormatted = formatDateStr(dataTime, 'YYYY-MM');
  // const isLoading = isLoadingProps || isLoadingInner;

  const { isDownloading, handleDownload } = useDownload({
    fileName: '',
    // fileName: 'Directory of Portfolio Studios',
    csvDownloadLogKey: 'STUDIO_OVERALL_OVERVIEW_DIRECTORY_OF_PORTFOLIO_STUDIOS_CSV_DOWNLOAD_SUBMIT',
    excelDownloadLogKey: 'STUDIO_OVERALL_OVERVIEW_DIRECTORY_OF_PORTFOLIO_STUDIOS_EXCEL_DOWNLOAD_SUBMIT',
    downloadService: createDownloadService(downloadStudioOverallOverviewTableData),
  });
  const handleDownloadInPage = useMemoizedFn((params: Record<string, any>) => {
    handleDownload({
      ...fetchParams,
      ...params,
      file_type: Number.parseInt(params?.fileType, 10),
    });
  });

  return (
    <CardSlot
      title={
        <div className="dbg-studio-overall-key-information-title">
          Directory of Portfolio Studios
          {!!dataTimeFormatted && (
            <DataTime
              className="dbg-studio-overall-key-information-time"
              dateType="Month"
              date={dataTimeFormatted}
            />
          )}
        </div>
      }
      ref={rootNode}
      className="dbg-studio-overall-key-information"
    >
      {isLoadingProps && (
        <div style={{ padding: '0 20px' }}>
          <Loading loading style={{ height: 350 }} />
        </div>
      )}
      {isLoadingProps || (
        <>
          <Filter
            ref={filterComp}
            // @ts-ignore
            formModel={formModel}
            onChange={handleFilterChange}
            onSearch={handleSearchChange}
            loading={isLoadingProps}
            downloadDisabled={reqError}
            downloading={isDownloading}
            onDownload={handleDownloadInPage}
          />
          <TableList
            // isTableColumnWrap={isTableColumnWrap}
            isTableInnerLoading={isTableInnerLoading}
            categoryFormatter={categoryFormatter}
            businessFormatter={businessFormatter}
            orderState={orderState}
            onOrderStateChange={handleOrderStateChange}
            records={records}
            currentParams={currentParams}
            prevParams={prevParams}
            reqError={reqError}
            onTableStatusChange={handleTableStatusChange}
          />
        </>
      )}
    </CardSlot>
  );
};

export default memo(KeyInformationTable);
